import { render, staticRenderFns } from "./userpage.vue?vue&type=template&id=805e32aa&scoped=true&"
import script from "./userpage.vue?vue&type=script&lang=js&"
export * from "./userpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805e32aa",
  null
  
)

export default component.exports